import React, { useState } from 'react'

import Button from 'components/common/Button/Button'
import { CopyButton } from 'components/common/CopyButton'
import { GRAY_700 } from 'constants/styling/theme'
import Typography from '@mui/material/Typography'
import styles from './AdminTools.module.sass'
import { useAuth0 } from 'utils/auth'

const maskToken = (token: string): string =>
  token.length <= 12 ? token : `${token.slice(0, 6)}…${token.slice(-6)}`

export const TokenPanel: React.FC = () => {
  const { getTokenSilently } = useAuth0()
  const [token, setToken] = useState('')
  const [revealed, setRevealed] = useState(false)
  const [loading, setLoading] = useState(false)

  const generate = async () => {
    setLoading(true)
    try {
      setToken(await getTokenSilently())
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={styles.tokenPanel}>
      <div className={styles.runRow}>
        <Button type="primary" height="thin" isLoading={loading} onClick={generate}>
          {token ? 'Refresh token' : 'Generate token'}
        </Button>
        {token && (
          <>
            <CopyButton copyText={token} type="secondary" buttonSize="sm" copySuccessText="Copied" textContent="Copy token" />
            <Button type="secondary nobackground" height="thin" onClick={() => setRevealed(value => !value)}>
              {revealed ? 'Hide' : 'Reveal'}
            </Button>
          </>
        )}
      </div>
      {token && (
        <code className={styles.tokenValue}>{revealed ? token : maskToken(token)}</code>
      )}
      {!token &&
        <Typography variant="text-sm" color={GRAY_700}>Generate a bearer token to copy into Swagger or other tools.</Typography>
      }
    </div>
  )
}
